<template>
	<v-content>
		<v-container fluid>

			<div class="records">

				<table>
					<thead>
						<tr>
							<th width="100px">Durum</th>
							<th width="10px">Yön</th>
							<th>Arayan</th>
							<th>Aranan</th>
							<th width="100px">Süre</th>
							<th width="170px">Tarih</th>
							<th width="10px"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(record,recordIndex) in records" :key="recordIndex">
							<td>
								<div :class="{isSuccess : record.answered, isFailed : !record.answered}">
									{{ record.durum }}</div>
							</td>
							<td>
								<v-icon dark v-if="record.incoming">keyboard_arrow_down</v-icon>
								<v-icon dark v-if="!record.incoming" class="outgoing">keyboard_arrow_up</v-icon>
							</td>
							<td>{{ record.source }}</td>
							<td>{{ record.target }}</td>
							<td>{{ record.sure }} sn</td>
							<td align=right>
								<div>{{ record.zaman }}</div>
								<div class="timediff"> {{ record.timestamp | moment("from") }} </div>
							</td>
							<td>
								<v-btn fab small color="white" :href="record.download" target="_blank">
									<v-icon>cloud_download</v-icon>
								</v-btn>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="loaders">
					<template v-if="loading">
						<v-progress-linear :indeterminate="true"></v-progress-linear>
					</template>
					<template v-if="!loading">
						<div class="text-xs-center" @click="doGetRecords()">
							<v-btn round color="primary" dark>Daha Fazla Göster</v-btn>
						</div>
					</template>
				</div>
			</div>

		</v-container>
	</v-content>

</template>


<script>
	export default {
		name: "ModulesSanalsantral",

		data: () => ({
			currentPage: 0,
			records: [],
			loading: true
		}),
		mounted() {
			this.doGetRecords()
		},
		methods: {
			doGetRecords() {
				this.loading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/modules/sanalsantral/?page=" + this.currentPage).then(
					response => {
						var data = response.body;
						var sonuclar = data.sonuclar;
						for (var i in sonuclar) {
							sonuclar[i].isPlaying = false
							sonuclar[i].voicesource = process.env.VUE_APP_API_URL +
								"/modules/sanalsantral/voice/?id=" + sonuclar[i].uniqueid
							this.records.push(sonuclar[i])

						}
						this.currentPage++;
						this.loading = false;
					})
			},
		}
	}
</script>



<style lang="less" scoped>
	.records {
		table {
			font-family: Roboto, sans-serif;
			font-family: arial;
			background-color: #242833;
			border-collapse: collapse;
			box-sizing: border-box;
			color: rgb(255, 255, 255);

			line-height: 24px;
			margin-bottom: 16px;
			text-align: left;
			width: 100%;
			font-weight: 400;

			thead {
				tr {
					th {
						border: 1px solid rgb(69, 77, 85);
						box-sizing: border-box;
						color: rgb(255, 255, 255);
						padding: 12px;
						vertical-align: top;
					}
				}
			}

			tbody {
				tr {
					td {
						background: #242833;
						box-sizing: border-box;
						color: rgb(255, 255, 255);
						padding: 12px;
						vertical-align: middle;
						font-family: arial;

					}
				}

				tr:nth-child(odd) td {
					background: #2e323d;
				}
			}
		}

		.timediff {
			font-size: 12px;
			line-height: 13px;
			color: #ffd500;
		}

		.isSuccess {
			color: #00ff4c;
		}

		.isFailed {
			color: #f30
		}

		.outgoing {
			opacity: 0.2;
		}

		.loaders{
			height: 150px;
		}
	}
</style>